module.exports = __webpack_public_path__ + "static/img/BD.b37f6c88.svg";